import { render, staticRenderFns } from "./WayGoods.vue?vue&type=template&id=105f0a03&scoped=true&"
import script from "./WayGoods.vue?vue&type=script&lang=js&"
export * from "./WayGoods.vue?vue&type=script&lang=js&"
import style0 from "./WayGoods.vue?vue&type=style&index=0&id=105f0a03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f0a03",
  null
  
)

export default component.exports